var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCB121;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.9,1H19.1c-3.4,0-6.7,1.4-9.1,3.8c-2.4,2.4-3.8,5.7-3.8,9.1v36.2c0,3.4,1.4,6.7,3.8,9.1 c2.4,2.4,5.7,3.8,9.1,3.8h25.9c3.4,0,6.7-1.4,9.1-3.8c2.4-2.4,3.8-5.7,3.8-9.1V13.9c0-3.4-1.4-6.7-3.8-9.1C51.7,2.3,48.4,1,44.9,1 L44.9,1z M19.1,6.1h25.9c2.1,0,4,0.8,5.5,2.3c1.5,1.5,2.3,3.4,2.3,5.5v31H11.3v-31c0-2.1,0.8-4,2.3-5.5S17,6.1,19.1,6.1z M44.9,57.9 H19.1c-2.1,0-4-0.8-5.5-2.3c-1.5-1.5-2.3-3.4-2.3-5.5h18.1v2.6c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.1,0.8,1.8,0.8 c0.7,0,1.3-0.3,1.8-0.8c0.5-0.5,0.8-1.1,0.8-1.8v-2.6h18.1c0,2.1-0.8,4-2.3,5.5C49,57.1,47,57.9,44.9,57.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.252210db77a4b8d01019686b09ae1e3b.svg";
export { ForwardRef as ReactComponent };